import { listenTid, emitter } from './utils/storage';
import './styles/page-base.less';
export * from './utils';
export * from './constants/login';
export * from './constants/company';
export * from './types';
export var loginEmitter = emitter;
listenTid();